import envVar from "env-var";
import { config } from "dotenv";

if (!process?.client && !process?.env?.isDotReady) {
  process.env.isDotReady = "1";
  config();
}

// eslint-disable-next-line import/no-named-as-default-member
export const { get: getEnv } = envVar;
